import { Group } from '@/components/_common';
import {
  Checkbox,
  Col,
  Form,
  FormInstance,
  Popover,
  Radio,
  Row,
  Skeleton,
  Typography,
} from 'antd';
import { ReactNode } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';

interface Props {
  form: FormInstance;
  extra?: ReactNode;
  loading?: boolean;
}

export default function CompanyFinancialSettingsForm({
  form,
  extra,
  loading,
}: Props) {
  const isInstallmentFree = Form.useWatch('isInstallmentFree', form);

  return (
    <Form layout="vertical" form={form} name="companyBudget">
      <div className="page-header" style={{ marginBottom: '24px' }}>
        <Typography.Title level={3}>
          <FormattedMessage id="layout.menu.registry.companies.settings.financial" />
        </Typography.Title>

        {extra && <div className="actions">{extra}</div>}
      </div>

      <Skeleton active loading={loading}>
        <Row gutter={[16, 8]}>
          <Col span={24}>
            <Typography.Title level={4}>Venda direta</Typography.Title>

            <Form.Item name="isInstallmentFree" labelAlign="left">
              <Radio.Group>
                <Radio value={true}>
                  <FormattedMessage id="companies.settings.form.withInstallments" />
                </Radio>
                <Radio value={false}>
                  <FormattedMessage id="companies.settings.form.withInstallmentsPaymentConditions" />
                </Radio>
              </Radio.Group>
            </Form.Item>

            {!isInstallmentFree && (
              <Group>
                <Form.Item
                  name="shouldUpdateDueDateBasedOnCreationDate"
                  initialValue={false}
                  valuePropName="checked"
                  noStyle
                >
                  <Checkbox>
                    Definir data de vencimento com referência na data da venda
                  </Checkbox>
                </Form.Item>

                <Popover
                  title="Definir a data inicial de vencimento das parcelas"
                  content={
                    <div style={{ maxWidth: 400 }}>
                      Ao selecionar esta opção, a data de vencimento da
                      <strong>primeira parcela</strong> será a mesma data da
                      venda. As demais parcelas seguirão o intervalo definido
                      nas condições de pagamento.
                    </div>
                  }
                >
                  <FaQuestionCircle size={12} />
                </Popover>
              </Group>
            )}
          </Col>
        </Row>
      </Skeleton>
    </Form>
  );
}
